export interface ProcessStep {
  title: string;
  description: string;
  artifact: string;
}

export const processSteps: ProcessStep[] = [
  {
    title: 'Discovery',
    description: 'A short call to map your goals, constraints, and the specific outcome you need shipped.',
    artifact: 'Clear next steps and a recommended scope',
  },
  {
    title: 'Strategy',
    description:
      'Architecture, data model, and UI flows agreed before we write production code, so the build has no surprises.',
    artifact: 'Technical plan and roadmap',
  },
  {
    title: 'Development',
    description:
      'Iterative builds with auth, role-based access, audit logs, CI/CD, and monitoring shipped alongside features.',
    artifact: 'Working software you can review as it grows',
  },
  {
    title: 'Launch & Support',
    description: 'Deploy, monitor, and keep improving. We stay on after launch to patch, scale, and keep things running.',
    artifact: 'Production release and a support plan',
  },
];
